import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SmsTemplate from "./SmsTemplate";
import GridConfig from "../GridConfig";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class SmsTemplates extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            isGlobal: props.IsGlobal,
            controllerName: 'smstemplates',
            data: null,
            loading: true,
            configName: 'smstemplate_grid',
            moduleName: 'الگوهای پیامکی'
        };
        this.state.filters = {
            isGlobal: this.state.isGlobal
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <SmsTemplate Caller={this} IsGlobal={this.state.isGlobal } Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <SmsTemplate Caller={this} IsGlobal={this.state.isGlobal} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "organizationName", caption: "شرکت", show: this.state.isGlobal },
                { field: "statusString", caption: "وضعیت", show: true },
                { field: "code", caption: "کد", show: this.state.isGlobal },
                { field: "order", caption: "اولویت نمایش", show: !this.state.isGlobal },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, flex: 4, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'organizationName' && f.show) t.push({ field: f.field, flex: 2, headerName: f.caption });
            if (f.field == 'statusString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'order' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', filter: false, headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>
            ]}
        });
        return t;
    }
    renderForm() {
        return <div className="nk-content-body">
            <div className="nk-block">
                <div className="card card-bordered card-stretch">
                    <div className="card-inner-group">
                        <div className="card-inner p-0">
                                {this.getToolBar(false, { add: true, print: false, pdf: false, excell: false, remove: false, config:false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}